"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var countdown_1 = tslib_1.__importDefault(require("../countdown/countdown"));
var date_1 = require("../../../common/utils/date");
var build_url_1 = require("../../../common/utils/url/build-url");
var open_popup_1 = tslib_1.__importDefault(require("../../../common/utils/open-popup"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var live_label_scss_1 = tslib_1.__importDefault(require("./live-label.scss"));
var ScheduledIcon_1 = tslib_1.__importDefault(require("../../../icons/compiled/components/ScheduledIcon"));
var inline_icon_1 = tslib_1.__importDefault(require("../inline-icon/inline-icon"));
var defaultDateFormat = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
};
var toShortISOWithoutDelimiters = function (datetime) {
    return new Date(datetime).toISOString().replace(/-|:|\.\d+/g, '');
};
var LiveLabel = /** @class */ (function (_super) {
    tslib_1.__extends(LiveLabel, _super);
    function LiveLabel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openGoogleCalendarEvent = function (e) {
            var _a = _this.props, startTime = _a.startTime, liveText = _a.liveText, videoTitle = _a.videoTitle;
            var startTimeShortISO = toShortISOWithoutDelimiters(startTime);
            var url = (0, build_url_1.buildUrl)('https://www.google.com/calendar/event', {
                action: 'TEMPLATE',
                dates: "".concat(startTimeShortISO, "/").concat(startTimeShortISO),
                text: videoTitle,
                location: '',
                details: liveText,
            });
            (0, open_popup_1.default)(url);
            e.stopPropagation();
        };
        return _this;
    }
    LiveLabel.prototype.renderReminder = function () {
        var _a;
        var _b = this.props, reminderIcon = _b.reminderIcon, noBackground = _b.noBackground, reminderAriaLabel = _b.reminderAriaLabel, isRTL = _b.isRTL;
        if (!reminderIcon) {
            return null;
        }
        var styleName = (0, classnames_1.default)(live_label_scss_1.default.reminder, (_a = {},
            _a[live_label_scss_1.default['no-bckg']] = noBackground,
            _a[live_label_scss_1.default.rtl] = isRTL,
            _a[live_label_scss_1.default.ltr] = !isRTL,
            _a));
        return (react_1.default.createElement("button", { onClick: this.openGoogleCalendarEvent, tabIndex: 0, role: "link", className: styleName, "aria-label": reminderAriaLabel }, reminderIcon));
    };
    LiveLabel.prototype.renderLiveStreamLabel = function () {
        var _a;
        var _b = this.props, isSmall = _b.isSmall, className = _b.className, liveText = _b.liveText, isRTL = _b.isRTL;
        var styleNames = (0, classnames_1.default)(live_label_scss_1.default['live-label'], className, live_label_scss_1.default['live-stream-label'], (_a = {},
            _a[live_label_scss_1.default.small] = isSmall,
            _a[live_label_scss_1.default.rtl] = isRTL,
            _a[live_label_scss_1.default.ltr] = !isRTL,
            _a));
        return (react_1.default.createElement("div", { "data-hook": "live-stream-label", className: styleNames, role: "note", "aria-label": liveText }, liveText));
    };
    LiveLabel.prototype.renderPendingLiveStreamLabel = function () {
        var _a;
        var _b = this.props, isSmall = _b.isSmall, className = _b.className, pendingLiveText = _b.pendingLiveText, isRTL = _b.isRTL;
        var styleNames = (0, classnames_1.default)(live_label_scss_1.default['live-label'], className, live_label_scss_1.default['live-stream-label'], live_label_scss_1.default['live-stream-pending-label'], (_a = {},
            _a[live_label_scss_1.default.small] = isSmall,
            _a[live_label_scss_1.default.rtl] = isRTL,
            _a[live_label_scss_1.default.ltr] = !isRTL,
            _a));
        return (react_1.default.createElement("div", { "data-hook": "live-stream-pending-label", className: styleNames, role: "note", "aria-label": pendingLiveText }, pendingLiveText));
    };
    LiveLabel.prototype.mapPropsToStyles = function () {
        var _a, _b, _c, _d, _e;
        var _f = this.props, isRTL = _f.isRTL, noBackground = _f.noBackground, className = _f.className;
        var liveTextStyle = (0, classnames_1.default)(live_label_scss_1.default['live-text'], (_a = {},
            _a[live_label_scss_1.default.rtl] = isRTL,
            _a[live_label_scss_1.default.ltr] = !isRTL,
            _a));
        var textStyle = (0, classnames_1.default)(live_label_scss_1.default['live-scheduled-label'], (_b = {},
            _b[live_label_scss_1.default['no-bckg']] = noBackground,
            _b[live_label_scss_1.default.rtl] = isRTL,
            _b[live_label_scss_1.default.ltr] = !isRTL,
            _b));
        var soonLabelStyle = (0, classnames_1.default)(live_label_scss_1.default['live-label'], className, (_c = {},
            _c[live_label_scss_1.default['no-bckg']] = noBackground,
            _c[live_label_scss_1.default.rtl] = isRTL,
            _c[live_label_scss_1.default.ltr] = !isRTL,
            _c));
        var scheduledLabelBigStyle = (0, classnames_1.default)(live_label_scss_1.default['live-label'], className, (_d = {},
            _d[live_label_scss_1.default.rtl] = isRTL,
            _d[live_label_scss_1.default.ltr] = !isRTL,
            _d));
        var countdownStyle = (0, classnames_1.default)(live_label_scss_1.default.countdown, (_e = {},
            _e[live_label_scss_1.default.rtl] = isRTL,
            _e[live_label_scss_1.default.ltr] = !isRTL,
            _e));
        return {
            liveTextStyle: liveTextStyle,
            textStyle: textStyle,
            soonLabelStyle: soonLabelStyle,
            scheduledLabelBigStyle: scheduledLabelBigStyle,
            countdownStyle: countdownStyle,
        };
    };
    LiveLabel.prototype.renderScheduledSoonLabel = function () {
        var _a = this.props, startTime = _a.startTime, liveText = _a.liveText, scheduledSoonAriaLabel = _a.scheduledSoonAriaLabel, startsInAriaLabel = _a.startsInAriaLabel;
        var _b = this.mapPropsToStyles(), liveTextStyle = _b.liveTextStyle, textStyle = _b.textStyle, countdownStyle = _b.countdownStyle, labelStyle = _b.soonLabelStyle;
        return (react_1.default.createElement("div", { "data-hook": "scheduled-soon-label", className: labelStyle, "aria-label": scheduledSoonAriaLabel },
            react_1.default.createElement("div", { className: textStyle },
                react_1.default.createElement("span", { className: liveTextStyle }, liveText + ':'),
                react_1.default.createElement(countdown_1.default, { className: countdownStyle, until: startTime, titlePrefix: startsInAriaLabel, isFocusable: true })),
            this.renderReminder()));
    };
    LiveLabel.prototype.renderScheduledLabelSmall = function () {
        var _a;
        var _b = this.props, smallClassName = _b.smallClassName, className = _b.className, scheduledAriaLabel = _b.scheduledAriaLabel, isRTL = _b.isRTL;
        var styleNames = (0, classnames_1.default)(live_label_scss_1.default['live-label'], className, smallClassName, live_label_scss_1.default['live-scheduled-icon'], (_a = {},
            _a[live_label_scss_1.default.rtl] = isRTL,
            _a[live_label_scss_1.default.ltr] = !isRTL,
            _a));
        return (react_1.default.createElement("div", { "data-hook": "scheduled-icon", className: styleNames, role: "img", "aria-label": scheduledAriaLabel },
            react_1.default.createElement(inline_icon_1.default, { icon: react_1.default.createElement(ScheduledIcon_1.default, null) })));
    };
    LiveLabel.prototype.renderScheduledLabelBig = function () {
        var _a = this.props, startTime = _a.startTime, locale = _a.locale, liveText = _a.liveText, scheduledAriaLabel = _a.scheduledAriaLabel, dateFormat = _a.dateFormat;
        var _b = this.mapPropsToStyles(), liveTextStyle = _b.liveTextStyle, textStyle = _b.textStyle, labelStyle = _b.scheduledLabelBigStyle;
        var formattedDate = new Date(startTime).toLocaleString(locale, dateFormat);
        return (react_1.default.createElement("div", { "data-hook": "scheduled-label", className: labelStyle, "aria-label": scheduledAriaLabel, role: "region" },
            react_1.default.createElement("div", { tabIndex: 0, role: "region", className: textStyle },
                react_1.default.createElement("span", { className: liveTextStyle }, liveText + ':'),
                formattedDate),
            this.renderReminder()));
    };
    LiveLabel.prototype.render = function () {
        var _a = this.props, startTime = _a.startTime, isSmall = _a.isSmall, isReadyLiveStream = _a.isReadyLiveStream, isPendingLiveStream = _a.isPendingLiveStream, isScheduled = _a.isScheduled;
        if (isPendingLiveStream) {
            return this.renderPendingLiveStreamLabel();
        }
        if (isReadyLiveStream) {
            return this.renderLiveStreamLabel();
        }
        if (isScheduled) {
            if (isSmall) {
                return this.renderScheduledLabelSmall();
            }
            return startTime - Date.now() < date_1.MILLISECONDS.ONE_DAY
                ? this.renderScheduledSoonLabel()
                : this.renderScheduledLabelBig();
        }
        return null;
    };
    LiveLabel.defaultProps = {
        dateFormat: defaultDateFormat,
    };
    return LiveLabel;
}(react_1.default.Component));
exports.default = LiveLabel;
//# sourceMappingURL=live-label.js.map